import {STOPPAGE_ANALYSIS_SUB_PATH} from '@features/stoppage-analysis'
import {PLANT_EVENTS, SHIFT_SUMMARY} from '@hconnect/common/hproduce/config/cockpit'
import {PERFORMANCE_SEGMENT} from '@hconnect/common/hproduce/consts'
import {HrocChecklistsPathSegments} from '@widgets/hroc-checklists'

export const routeToEvents = PLANT_EVENTS
export const routeToEventChecklist = `${PLANT_EVENTS}/${HrocChecklistsPathSegments.Checklist}`
export const routeToEventChecklistsUnsupportedKind = `${routeToEventChecklist}/${HrocChecklistsPathSegments.UnsupportedKind}`
export const routeToTasks = '/:plantId/tasks'
export const routeToTasksChecklist = `${routeToTasks}/${HrocChecklistsPathSegments.Checklist}`
export const routeToTasksChecklistUnsupportedKind = `${routeToTasksChecklist}/${HrocChecklistsPathSegments.UnsupportedKind}`
export const routeToSummary = SHIFT_SUMMARY
export const routeToStoppageAnalysis = `${SHIFT_SUMMARY}/${STOPPAGE_ANALYSIS_SUB_PATH}`
export const routeToPerformance = `/:plantId/${PERFORMANCE_SEGMENT}`
export const routeToLabQualityResult = '/:plantId/lab-quality-result'
export const routeToManageShifts = '/:plantId/shifts'
export const routeToRecurringTasks = '/:plantId/recurring-tasks'
export const routeToDocuments = '/:plantId/documents'
export const routeToTermsConditions = '/:plantId/tc'
export const routeToPrivacyPolicy = '/:plantId/privacy'
export const routeToEventsAffiliates = '/:plantId/events-affiliates/:eventId'

type LinkTo = {
  to: string
  translationKey: string
  keepURLParams?: string[]
}

export const links: LinkTo[] = [
  {
    to: routeToTasks,
    translationKey: 'tasks.pageName'
  },
  {
    to: routeToEvents,
    translationKey: 'shiftEvent.pageName'
  },
  {
    to: routeToSummary,
    translationKey: 'summary.pageName'
  },
  {
    to: routeToPerformance,
    translationKey: 'performanceData.pageName'
  },
  {
    to: routeToDocuments,
    translationKey: 'documents.pageName'
  }
]

export const extendedLinks: LinkTo[] = [
  ...links,
  {
    to: routeToLabQualityResult,
    translationKey: 'labQualityResult.pageName'
  }
]
